import { render, staticRenderFns } from "./tabs-item.vue?vue&type=template&id=64fe6e69&"
import script from "./tabs-item.vue?vue&type=script&lang=js&"
export * from "./tabs-item.vue?vue&type=script&lang=js&"
import style0 from "./tabs-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports